var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100 w-100 m-0 p-0",attrs:{"id":"app"}},[_c('router-view'),_c('Alerts',{key:_vm.alerts_refresh,attrs:{"position":"bottom-right"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }